import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, getStoredLocale, LANGUAGE_KEY, locales } from '../../constants/locales';

type Props = {
  /** `dark` = white text on dark navbar (default). `light` = dark text on white menu. */
  variant?: 'dark' | 'light';
};

const LocaleSelector = ({ variant = 'dark' }: Props) => {
  const [selectedLocale, setSelectedLocale] = useState<string>(getStoredLocale);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!locales.includes(selectedLocale)) {
      setSelectedLocale(DEFAULT_LOCALE);
      localStorage.setItem(LANGUAGE_KEY, DEFAULT_LOCALE);
      return;
    }
    i18n.changeLanguage(selectedLocale);
  }, [selectedLocale, i18n]);

  const changeLanguage = (lng: string) => {
    setSelectedLocale(lng);
    localStorage.setItem(LANGUAGE_KEY, lng);
  };

  const isLight = variant === 'light';
  const textColor = isLight ? '#1a1a1a' : '#fff';
  const optionBg = isLight ? '#fff' : '#54a2ef';

  return (
    <div className={isLight ? 'w-[60px]' : 'w-[60px]'}>
      <select
        style={{ color: textColor }}
        className={`p-0 m-0 border-none bg-transparent focus:ring-0 w-full cursor-pointer text-body-lg leading-[1.5] ${
          isLight ? 'text-core-slate-1300' : 'text-core-white'
        }`}
        value={selectedLocale}
        onChange={(e) => {
          changeLanguage(e.target.value);
        }}
      >
        {locales.map((locale) => (
          <option
            key={locale}
            value={locale}
            style={{ color: textColor, backgroundColor: optionBg }}
          >
            {locale.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LocaleSelector;
